import presentRule from './present-rule'

export default async function (eventBus, placeholder = null) {
    const queue = window.addiesaas.store.getters['Marketing/CartRules/Session/queue']
    const ruleIds = queue.map(queued => queued.rule.id)

    for (const id of ruleIds) {
        const queued = queue.find(queued => queued.rule.id == id)

        if (queued) {
            const { rule, args } = queued

            if (
                (placeholder == null && rule.confirmation_options.event_notification_type != 'placeholder') ||
                rule.confirmation_options.notification_location == placeholder
            ) {
                presentRule(rule, eventBus, queued, args)
            }
        }
    }
}
